// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__I27PR","rootSmall":"AddTileButton_rootSmall__17CH8"};